import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { GetPastCrossGoodsSetListService } from './api-services/get-past-cross-goods-set-list.service';
import { UpdateTargetCrossGoodsInfoService } from './api-services/update-target-cross-goods-info.service';
import { KYMW4802Component } from './kymw4802.component';

/**
 * クロス商品設定画面 モジュール設定クラス
 *
 * @export KYMW4802Module
 * @class KYMW4802Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [KYMW4802Component],
  providers: [
    GetPastCrossGoodsSetListService,
    UpdateTargetCrossGoodsInfoService,
  ],
})
export class KYMW4802Module { }
